import React from "react"
import { FormattedMessage } from "react-intl"
import Integrations from "../../../integration/Integrations"
import { EventObjectDto } from "../../../state/event/Event"
import { INTEGRATION_KEY } from "../../../state/integration/Constants"
import { InvoiceDto } from "../../../state/invoice/models"
import DocumentEventExportedComponent from "./DocumentEventExportedComponent"

type OwnProps = {
    object: EventObjectDto
    invoice: InvoiceDto
}

const InvoiceCreatedFromFreshbooksEvent = (props: OwnProps) => {
    const type = props.object.attributes.entityType
    const Url = Integrations.getExternalOrderUrl(props.object)

    const renderMessage = () => {
        switch (type) {
        case "main":
            return <FormattedMessage
                id="invoice.analytics.events.exported.freshbooks.text"
                defaultMessage="Invoice {identifier} was exported to FreshBooks"
                values={{
                    identifier: <strong>{props.invoice.attributes.identifier}</strong>,
                }}
            />
        default:
            return <></>
        }
    }

    return <DocumentEventExportedComponent
        url={Url}
        exportedMainMessage={renderMessage()}
        buttonMessage={<FormattedMessage
            id="invoice.analytics.events.exported.FreshBooks.open"
            defaultMessage="Open invoice in FreshBooks"
        />}
        integrationLogo={{
            integrationKey: INTEGRATION_KEY.FRESHBOOKS,
            width: 120,
            height: 30,
        }}
    />
}


export default InvoiceCreatedFromFreshbooksEvent


// WEBPACK FOOTER //
// ./src/quote/analytics/events/invoice-exported-freshbooks.component.tsx